import { useContext } from 'react'
import styled from 'styled-components'
import { PredictionOfPassedContainerContext } from '@app.feature/exam/gsat2024-2/context/PredictionOfPassedContainerContext'
import {
  parseTestResultDate,
  calculateAgeFromTimestamp,
} from '@app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFive/module/testResult.module'
import PredictionPassedMarkMobile from './PredictionPassedMark.mobile'
import UserInfoTextLayoutMobile from './UserInfoTextLayout.mobile'

const TestUserInfoArticleMobile = () => {
  const { examReserveInformation, examGradingResultData, examTestsData } =
    useContext(PredictionOfPassedContainerContext)

  const examDate = parseTestResultDate({
    dateList: examTestsData || [],
    testId: examReserveInformation?.examTest.id || '',
    formatType: 'kor',
  })

  const userInfoList = [
    {
      label: '닉네임',
      value: examReserveInformation?.user.username || '',
    },
    {
      label: '생년월일',
      value: calculateAgeFromTimestamp(examReserveInformation?.user.birthday),
    },
    { label: '응시일자', value: examDate },
  ]

  const testInfoList = [
    {
      label: '계열사',
      value: examReserveInformation?.examSubsidiary.name || '',
    },
    {
      label: '사업부',
      value: examReserveInformation?.examDepartment.name || '',
    },
    { label: '직무', value: examReserveInformation?.examJob.name || '' },
  ]

  if (!examReserveInformation) return <></> // TODO 스켈레톤 처리 필요합니다

  return (
    <StyledWrapper>
      <PredictionPassedMarkMobile
        topPercent={examGradingResultData?.viewerRank || 0}
      />
      <div className="text-box">
        <UserInfoTextLayoutMobile title="기본 정보" list={userInfoList} />
        <UserInfoTextLayoutMobile title="응시 정보" list={testInfoList} />
      </div>
    </StyledWrapper>
  )
}

export default TestUserInfoArticleMobile

const StyledWrapper = styled.article`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 20px;
  padding: 24px 20px 32px;
  width: 100%;
  background-color: #fff;

  > .text-box {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 36px;
    margin-top: 16px;
  }
`
